module.exports = __webpack_public_path__ + "static/img/2.abeec43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/2.jpg
// module id = AqG0
// module chunks = 1